"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H7"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var _colors = require("HubStyleTokens/colors");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 27px;\n  padding-left: 8px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 16px;\n  line-height: 27px;\n  text-decoration: line-through;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 1em 12px;\n  align-items: center;\n\n  &.row {\n    margin: 0 0 10px;\n  }\n\n  &.price-row__total {\n    background-color: ", ";\n    padding: 1.75em 0.85em;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FeeRow = (0, _styledComponents.default)(_UIGrid.default).withConfig({
  displayName: "PriceBreakdownRow__FeeRow",
  componentId: "sc-1ujwv3w-0"
})(_templateObject(), _colors.GYPSUM);
var CrossedOutPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "PriceBreakdownRow__CrossedOutPrice",
  componentId: "sc-1ujwv3w-1"
})(_templateObject2(), _colors.PANTERA);
var DiscountedPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "PriceBreakdownRow__DiscountedPrice",
  componentId: "sc-1ujwv3w-2"
})(_templateObject3(), _colors.OZ);

var PriceBreakdownRow = function PriceBreakdownRow(_ref) {
  var text = _ref.text,
      subtext = _ref.subtext,
      price = _ref.price,
      priceDisclaimer = _ref.priceDisclaimer,
      currencyCode = _ref.currencyCode,
      isMonthly = _ref.isMonthly,
      isYearly = _ref.isYearly,
      isTotal = _ref.isTotal,
      fullPrice = _ref.fullPrice;
  return _react.default.createElement(FeeRow, {
    className: isTotal && 'price-row__total'
  }, _react.default.createElement(_UIGridItem.default, {
    size: 8,
    className: "text-left"
  }, _react.default.createElement(_UIFlex.default, {
    align: "start",
    justify: "center",
    direction: "column",
    wrap: "nowrap"
  }, _react.default.createElement("div", null, isTotal ? _react.default.createElement(_H2.default, {
    style: {
      margin: 0
    }
  }, text) : _react.default.createElement("p", {
    style: {
      margin: 0
    }
  }, text), _react.default.createElement(_Small.default, {
    style: {
      margin: 0,
      fontWeight: 400
    }
  }, subtext)))), _react.default.createElement(_UIGridItem.default, {
    size: 4,
    className: "text-right"
  }, _react.default.createElement(_UIFlex.default, {
    align: "end",
    justify: "center",
    direction: "column",
    wrap: "nowrap",
    className: "price-row__flex"
  }, _react.default.createElement(_H.default, {
    style: {
      margin: 0
    }
  }, fullPrice && fullPrice > price ? _react.default.createElement(_react.Fragment, null, _react.default.createElement(CrossedOutPrice, {
    currencyCode: currencyCode,
    price: fullPrice
  }), _react.default.createElement(DiscountedPrice, {
    currencyCode: currencyCode,
    price: price
  })) : _react.default.createElement(_PriceDisplay.default, {
    currencyCode: currencyCode,
    price: price
  }), (isMonthly || isYearly) && _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay." + (isMonthly ? 'perMonth' : 'perYear')
  })), _react.default.createElement(_Small.default, {
    style: {
      margin: 0,
      fontWeight: 400
    }
  }, priceDisclaimer))));
};

PriceBreakdownRow.propTypes = {
  text: _propTypes.default.node.isRequired,
  subtext: _propTypes.default.node,
  price: _propTypes.default.number.isRequired,
  currencyCode: _propTypes.default.string.isRequired,
  priceDisclaimer: _propTypes.default.node,
  isMonthly: _propTypes.default.bool,
  isYearly: _propTypes.default.bool,
  isTotal: _propTypes.default.bool,
  fullPrice: _propTypes.default.number
};
var _default = PriceBreakdownRow;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/PriceBreakdownRow.js
// module id = 464
// module chunks = 5 6